import { render } from "./Home.vue?vue&type=template&id=2746e7d2&ts=true"
import script from "./home.ts?vue&type=script&lang=ts&external"
export * from "./home.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__